import React from "react";

import { Skeleton } from "@libraries/mui";

import { KanbanSectionIconContainer } from "./styles";

interface KanbanSectionIconProps {
  iconPath: string;
}

const KanbanSectionIcon: React.FC<KanbanSectionIconProps> = ({ iconPath }) => (
  // <KanbanSectionIconContainer
  //   id="kanbanSectionIcon"
  //   src={iconPath}
  //   alt="kanban section icon"
  //   loading={() => <Skeleton variant="rectangular" animation="wave" width={35} height={35} />}
  // />
  <div />
);

export default React.memo(KanbanSectionIcon);
